export default "__VITE_ASSET__74b3f38f__"